/** True when this runtime exposes the WebAuthn API (desktop Chrome, Safari, etc.). */
export function browserSupportsWebAuthn(): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.PublicKeyCredential !== 'undefined';
  } catch {
    return false;
  }
}
